<template>
	<v-card class="settings-page pa-10 mt-8" flat>
		<v-alert v-model="successMessage" type="success" dismissible>
			Settings saved successfully.
		</v-alert>
		<v-alert v-model="errorMessage" type="error" dismissible> An error occurred. </v-alert>

		<v-card-text>
			<h1 class="mb-10">Settings</h1>

			<v-list class="sidebar-list pa-0">

				<v-list-item class="sidebar-list__item">
					<v-list-item-content class="sidebar-list__content text-decoration-underline">
						<a
							:href="baseSetting.termsOfUse"
							target='_blank'
							class="text-decoration-none"
						>
							<v-list-item-title class="sidebar-list__title">Terms of Use</v-list-item-title>
						</a>
					</v-list-item-content>
				</v-list-item>

				<v-list-item class="sidebar-list__item">
					<v-list-item-content class="sidebar-list__content text-decoration-underline">
						<a
							:href="baseSetting.privacy"
							target='_blank'
							class="text-decoration-none"
						>
							<v-list-item-title class="sidebar-list__title">Privacy Policy</v-list-item-title>
						</a>
					</v-list-item-content>
				</v-list-item>

				<v-list-item class="sidebar-list__item">
					<v-list-item-content class="sidebar-list__content text-decoration-underline">
						<a
							:href="baseSetting.contactUrl"
							target='_blank'
							class="text-decoration-none"
						>
							<v-list-item-title class="sidebar-list__title">Contact Us</v-list-item-title>
						</a>
					</v-list-item-content>
				</v-list-item>

			</v-list>

		</v-card-text>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ProfileForm from '@/components/Forms/settings/ProfileForm'
import SecurityForm from '@/components/Forms/settings/SecurityForm'
import NotificationsForm from '@/components/Forms/settings/NotificationsForm'

export default {
	name: 'SettingsPage',
	components: {
		NotificationsForm,
		ProfileForm,
		SecurityForm,
	},
	computed: {
		...mapGetters('settings', ['settings', 'baseCore']),

		isVerticalTabs() {
			return this.$vuetify.breakpoint.mdAndUp
		},
		baseSetting() {
			if (this.baseCore) {

				const {
					privacy_policy: privacy,
					terms_of_use: termsOfUse,
					contact_us_url: contactUrl
				} = this.baseCore || {}

				return {
					privacy,
					termsOfUse,
					contactUrl
				}
			}
		}
	},
	methods: {
		...mapActions('settings', ['fetchSettings', 'getBaseCoreSettings']),
		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		normalizeSettings(item) {
			const { setting, value } = item

			let settings = {}
			settings[setting.name] = value !== '0'

			return settings
		},
		getRoute(initValue) {
			const url = new URL(initValue);
			return url.pathname;
		}
	},
	data() {
		return {
			successMessage: false,
			errorMessage: false,
		}
	},
	created() {
		this.getBaseCoreSettings()
	},
}
</script>

<style lang="scss">
.settings-page {
	font-family: Montserrat,sans-serif;

	&.v-tabs {
		font-style: normal;
		font-weight: bold !important;
		font-size: 20px;
		line-height: 67px;
		text-transform: capitalize;
		justify-content: space-between;
		letter-spacing: 0.1px !important;
	}

	&__title {
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		line-height: 35px;
		color: #202232;
	}

	&__tabs {
		.v-tab {
			justify-content: space-between;
			font-style: normal;
			font-weight: 900;
			font-size: 20px;
			line-height: 67px;
			text-transform: capitalize;
			color: #cbcbcb !important;

			&--active {
				color: #4d536e !important;
			}
		}
	}

	@media screen and (max-width: 960px) {
		.settings-page__title {
			font-size: 25px !important;
		}
		.v-tabs-bar {
			display: contents;
		}
		.v-tab {
			font-size: 18px !important;
		}
	}
	@media screen and (max-width: 600px) {
		.v-card__text {
			padding: 0;
		}
		.v-tab {
			padding: 0 3px;
		}
	}
}
</style>
